import { render } from "./SubNav.vue?vue&type=template&id=c49a9d10&scoped=true"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"

import "./SubNav.vue?vue&type=style&index=0&id=c49a9d10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c49a9d10"

export default script